import axios from 'axios';

const API_URL = process.env.VUE_APP_API+'game/';

class GameService {
    getEvents(game_id) {
        return axios.get(API_URL + 'getEvents/?gid='+game_id);
    }
    getBetAliases(alias_code) {
        return axios.post(API_URL + 'getBetAliases/', {alias_name: alias_code});
    }
}

export default new GameService();